export default __webpack_public_path__ + "static/media/home_page_cell_phones.cb07b04d.png";